import {useCallback} from 'react';
import {useMutation} from '@apollo/client';
import updateBusPartnerBusCostEntryMutationV2 from '../graphql/updateBusPartnerBusCostEntryMutationV2';
import {PartnerCostsVehicleCost} from '../store/types';
import {receivedPartnerVehicleCostAction} from '../store/slice';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';

interface UseUpdateBusPartnerBusCostEntryV2MutationResult {
  updateBusPartnerBusCostEntry: (
    cost: PartnerCostsVehicleCost,
    busPartnerId: string,
    year: number,
    onSuccess?: (cost?: PartnerCostsVehicleCost) => void
  ) => Promise<void>;
}

export const useUpdateBusPartnerBusCostEntryV2Mutation =
  (): UseUpdateBusPartnerBusCostEntryV2MutationResult => {
    const dispatch = useAppDispatch();
    const [updateBusPartnerBusCostEntryV2] = useMutation(
      updateBusPartnerBusCostEntryMutationV2,
      {
        errorPolicy: 'all'
      }
    );

    const updateBusPartnerBusCostEntry = useCallback(
      async (
        cost: PartnerCostsVehicleCost,
        busPartnerId: string,
        year: number,
        onSuccess?: (cost?: PartnerCostsVehicleCost) => void
      ) => {
        try {
          const variables = {
            ...cost,
            busPartnerId,
            year
          };
          const result = await updateBusPartnerBusCostEntryV2({variables});

          if (result.errors && result.errors.length > 0) {
            const errorMessage = result.errors[0].message;
            console.error(errorMessage);
            return;
          }

          dispatch(
            receivedPartnerVehicleCostAction(
              result.data.updateBusPartnerBusCostEntryV2
            )
          );
          onSuccess?.(result.data.updateBusPartnerBusCostEntryV2);
        } catch (err: any) {
          console.error(
            `Unexpected error while updating bus partner bus cost entry: ${err}`
          );
        }
      },
      [dispatch, updateBusPartnerBusCostEntryV2]
    );

    return {updateBusPartnerBusCostEntry};
  };
